import { Fragment } from "react";
import { CircleX } from "lucide-react";
import ActionBtnU from "../../Users/components/ActionBtnU";

export const DeleteMessage = ({
  setIsDialogOpen,
  handleDialogClose,
  handlePauseSubscription,
  selectedSubscription,
  loading,
  action,
}: {
  setIsDialogOpen: any;
  handleDialogClose: () => void;
  handlePauseSubscription: (subscription: any) => void;
  loading: boolean;
  selectedSubscription: any;
  action: "pause" | "delete";
}) => {
  const getActionMessage = () => {
    if (action === "pause") {
      if (selectedSubscription?.Status__c === "Active") {
        return "Pausing a subscription will stop it from sending reports, but you can resume it later.";
      }
      return "You will start receiving reports again as scheduled.";
    }
    return "You will permanently delete this subscription and can't be undone.";
  };

  const getActionHeader = () => {
    if (action === "pause") {
      if (selectedSubscription?.Status__c === "Active") {
        return "Do you want to pause this subscription?";
      }
      return "Do you want to resume this subscription?";
    }
    return "Do you want to delete this subscription?";
  };

  return (
    <Fragment>
      <div className="relative flex">
        <h1 className="mb-4 text-left text-lg font-semibold sm:w-full">
          {getActionHeader()}
        </h1>
        <button
          className="top-1 cursor-pointer border-0 bg-transparent sm:absolute sm:right-0"
          onClick={() => setIsDialogOpen()}
        >
          <CircleX className="h-5 w-5" />
        </button>
      </div>
      <div>
        <p className="mb-4 text-left text-sm text-gray-500">
          {getActionMessage()}
        </p>

        {action === "delete" && (
          <p className="w-fit rounded-md bg-red-100 p-2 text-left text-xs text-red-500">
            Delete Cannot be Undone
          </p>
        )}
      </div>
      <div className="mt-7 flex items-center justify-end space-x-4">
        {action === "pause" && (
          <ActionBtnU
            largeWidth="30%"
            onClick={() => handlePauseSubscription(selectedSubscription)}
            purpleBg
            white_color
            disabled={loading}
          >
            {selectedSubscription?.Status__c === "Active" ? "Pause" : "Resume"}
          </ActionBtnU>
        )}
        {action === "delete" && (
          <ActionBtnU
            largeWidth="30%"
            onClick={() => handleDialogClose()}
            redBg
            white_color
            disabled={loading}
          >
            Delete
          </ActionBtnU>
        )}
      </div>
    </Fragment>
  );
};
